export default __webpack_public_path__ + "static/media/arrow-left.e037d19f.svg";